import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import api from '@/services/axiosApi'
import { useConnectionStore } from '@/stores/connectionStore'
import { monitorPusherConnection } from '@/services/realtimeConnectionMonitor'
import type { PusherConnection } from '@/services/realtimeConnectionMonitor'
window.Pusher = Pusher

type EchoChannel = {
  name: string
}

type EchoAuthCallback = (error: boolean, data: unknown) => void

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: Number(import.meta.env.VITE_REVERB_PORT ?? 80),
  wssPort: Number(import.meta.env.VITE_REVERB_PORT ?? 443),
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws'],
  disableStats: true,
  authorizer: (channel: EchoChannel) => {
    return {
      authorize: (socketId: string, callback: EchoAuthCallback) => {
        api
          .post(
            `${import.meta.env.VITE_APP_BACKEND_HOST}/api/broadcasting/auth`,
            {
              socket_id: socketId,
              channel_name: channel.name
            }
          )
          .then((response) => {
            callback(false, response.data)
          })
          .catch((error) => {
            callback(true, error)
          })
      }
    }
  }
})

export function initializeRealtimeConnectionMonitoring() {
  const connectionStore = useConnectionStore()
  const pusher = window.Echo?.connector?.pusher

  connectionStore.setDiagnostics({
    appKey: import.meta.env.VITE_REVERB_APP_KEY ?? null,
    wsHost: import.meta.env.VITE_REVERB_HOST ?? null
  })

  connectionStore.registerRetry(() => {
    if (!pusher) {
      return
    }

    pusher.disconnect()
    window.setTimeout(() => pusher.connect(), 0)
  })

  connectionStore.startBrowserConnectivityMonitoring()
  monitorPusherConnection(pusher?.connection as PusherConnection | undefined, connectionStore)
}
